/**
 * @generated SignedSource<<9c82bd32fed659b538271dccdfd849fd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type field_AtlassianConversationAssistantPreviewCard$data = {
  readonly __typename: string;
  readonly fieldConfig?: {
    readonly isRequired: boolean | null;
  } | null;
  readonly fieldId: string;
  readonly " $fragmentSpreads": FragmentRefs<"JiraCascadingSelectField_Platform" | "JiraCheckboxesField_Platform" | "JiraComponentsField" | "JiraDatePickerField_Platform" | "JiraDateTimePickerField_Platform" | "JiraLabelsField_Platform" | "JiraMultipleSelectField" | "JiraMultipleSelectUserPickerField_Platform" | "JiraNumberField_Platform" | "JiraPeopleField_Platform" | "JiraPriorityField_Platform" | "JiraRadioSelectField_Platform" | "JiraRichTextField_Platform" | "JiraSingleLineTextField_Platform" | "JiraSingleSelectField_Platform" | "JiraSingleSelectUserPickerField_Platform" | "JiraSprintField_Platform" | "JiraTimeTrackingField_Platform" | "JiraUrlField_Platform">;
  readonly " $fragmentType": "field_AtlassianConversationAssistantPreviewCard";
};
export type field_AtlassianConversationAssistantPreviewCard$key = {
  readonly " $data"?: field_AtlassianConversationAssistantPreviewCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"field_AtlassianConversationAssistantPreviewCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "field_AtlassianConversationAssistantPreviewCard",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraFieldConfig",
          "kind": "LinkedField",
          "name": "fieldConfig",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isRequired"
            }
          ]
        }
      ],
      "type": "JiraIssueFieldConfiguration",
      "abstractKey": "__isJiraIssueFieldConfiguration"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraSingleLineTextField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraRichTextField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraSingleSelectUserPickerField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraMultipleSelectUserPickerField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraPeopleField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraPriorityField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraSingleSelectField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraDatePickerField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraDateTimePickerField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraNumberField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraTimeTrackingField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraRadioSelectField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraMultipleSelectField"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraLabelsField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraCascadingSelectField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraCheckboxesField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraUrlField_Platform"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraComponentsField"
    },
    {
      "kind": "FragmentSpread",
      "name": "JiraSprintField_Platform"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "c61606bf06f6391e91c28975c50b3d90";

export default node;
